import checkIcon from "../../../assets/icons/check-icon-white.svg";

type Props<T> = {
    value: T;
    label: string;
    active: boolean;
    onClick: (value: T) => void;
    icon?: string;
};

function PhysiologicalSystemButton<T>({
    value,
    label,
    active,
    onClick,
    icon,
}: Props<T>) {
    return (
        <button
            className={`text-white font-manrope text-start text-base xl:text-lg leading-snug w-full h-9 xl:h-12 flex items-center rounded-sm gap-1 xl:gap-2 px-1.5 xl:px-[18px] hover:shadow-[0px_2px_4px_0px_#00000040] ${
                active ? "bg-blue-dark  font-bold" : "bg-blue-option"
            }`}
            onClick={() => onClick(value)}
        >
            {icon ? (
                <img src={icon} alt="Check Icon" className="w-5 h-5" />
            ) : active ? (
                <img
                    src={checkIcon}
                    alt="Check Icon"
                    className="w-4 h-4 max-xl:hidden"
                />
            ) : (
                <div className="w-4 h-4 max-xl:hidden" />
            )}
            {label}
        </button>
    );
}

export default PhysiologicalSystemButton;
